import Link from 'next/link'

import BreadcrumbsStructuredDataSEO from 'components/SEO/BreadcrumbsStructuredDataSEO'
import { StyledBreadCrumbs } from './Styled'

const Breadcrumbs = ({ directoryLinkInformation, breadCrumbsData }) => {
  const breadCrumbsLength = breadCrumbsData.length - 1
  const breadCrumbsStructuredData = []
  if (
    !directoryLinkInformation ||
    breadCrumbsLength <= 0 ||
    (breadCrumbsData[1] &&
      breadCrumbsLength === 1 &&
      (breadCrumbsData[1].name === 'Canada' || breadCrumbsData[1].name === 'USA'))
  ) {
    return null
  }

  const breadCrumbsLinks = breadCrumbsData.map((breadCrumb, i) => {
    breadCrumbsStructuredData.push({
      position: i,
      name: breadCrumb.name,
      item: breadCrumb.path,
    })
    return (
      <Link key={i} href={breadCrumb.path} scroll={false}>
        <StyledBreadCrumbs>
          {breadCrumb.name} {i !== breadCrumbsLength && ' > '}
        </StyledBreadCrumbs>
      </Link>
    )
  })

  return (
    <>
      {breadCrumbsLinks}
      <BreadcrumbsStructuredDataSEO breadCrumbsStructuredData={breadCrumbsStructuredData} />
    </>
  )
}

export default Breadcrumbs
